import useJwt from "@/auth/jwt/useJwt"
import ability from "@/libs/acl/ability"
import axios from "axios"

export const urlHasToken = () => {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  const token = urlParams.get("token")

  if (!token) return null

  const cleanedToken = token.split("|")[1] ?? null

  return cleanedToken
}

export const getTokenValidationUrl = () => {
  return `${process.env.VUE_APP_API_URL}/auth/validate`
}

export const fetchValidateToken = async () => {
  const accessToken = await localStorage.getItem("accessToken")

  if (!accessToken) return

  const url = await getTokenValidationUrl()

  axios
    .post(url, {
      device_name: "web",
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) => {
      useJwt.setToken(response.data.accessToken)
      useJwt.setRefreshToken(response.data.accessToken)
      localStorage.setItem(

        "userData",
        JSON.stringify(response.data.userData),
      )

      ability.update(response.data.userData.ability)
    })
    .catch((err) => {
      console.error(err)
    //   localStorage.clear()
    //   window.location.href = `${process.env.VUE_APP_URL}/login`
    })
}
